import { createReducer, on } from '@ngrx/store';

import * as AppActions from './actions';
import { AppState } from '../shared/models';

export const initialState: AppState = {
  nutrientCategories: null,
};

export const reducer = createReducer<AppState>(
  initialState,
  on(AppActions.loadNutrientCategoriesSuccess, (state, { nutrientCategories }) => ({
    ...state,
    nutrientCategories,
  })),
);
